import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface AgentMarkdownProps {
  text: string;
}

/**
 * Theragenie's answer as formatted text: the model writes Markdown (bold, lists, tables), and shown
 * raw it reads as a wall of asterisks. HTML in the answer is not rendered — only Markdown — so a
 * model that echoes markup from a document cannot inject it into the page. Links open in a new tab.
 */
export function AgentMarkdown({ text }: AgentMarkdownProps) {
  return (
    <div className="pa-markdown">
      <ReactMarkdown remarkPlugins={[remarkGfm]} skipHtml
        components={{ a: ({ href, children }) => <a href={href} target="_blank" rel="noreferrer noopener">{children}</a> }}>
        {text}
      </ReactMarkdown>
    </div>
  );
}
